import { Layout } from "antd"
import { DefaultHeader } from "components/molecules"
import React from "react"
import { Outlet } from "react-router-dom"
import styled from "styled-components"

const { Content } = Layout

const StyledLayout = styled(Layout)`
  min-height: 100vh;
`
export const AuthLayout = () => {
  return (
    <StyledLayout className="layout">
      <DefaultHeader />
      <Content>
        <Outlet />
      </Content>
    </StyledLayout>
  )
}
